import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SiModalModule } from '../../../../components';

@Component({
  templateUrl: './confirmation-delete.component.html',
  styleUrls: ['./confirmation-delete.component.scss'],
  imports: [
    SiModalModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationDeleteComponent {

}
